import React from "react";
import { formatLBP, formatUSD } from "../../../../features/ValueFormater";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-GB");
}

function formatAmount(row) {
  const currency = String(row?.Currency || row?.currency || "USD").toUpperCase();
  const amount = row?.Amount ?? row?.amount ?? 0;
  return currency === "LBP"
    ? `Amount: L.L ${formatLBP(amount)}`
    : `Amount: $${formatUSD(amount)}`;
}

function normalizeRecentPayment(row) {
  return {
    id: row?.Transaction || row?.Reference || row?.RowId || row?.id,
    title: row?.Recipient || row?.Beneficiary || row?.ReceiverName || "-",
    date: formatDate(row?.Date || row?.date),
    amount: formatAmount(row),
    method: row?.Method || row?.TransactionType || "Suyool to Suyool",
  };
}

export default function RecentPaymentsCard({ rows = [] }) {
  const payments = (Array.isArray(rows) ? rows : [])
    .slice(0, 5)
    .map(normalizeRecentPayment);

  return (
    <aside className="make-payment-recent" aria-labelledby="recent-payments-title">
      <h2 id="recent-payments-title">Recent Payments</h2>

      {payments.length ? (
        <div className="make-payment-recent__list">
          {payments.map((payment, index) => (
            <article
              key={payment.id || `${payment.title}-${index}`}
              className="make-payment-recent__item"
            >
              <div>
                <strong>{payment.title}</strong>
                <span>{payment.amount}</span>
              </div>
              <div>
                <time>{payment.date}</time>
                <span>{payment.method}</span>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="make-payment-recent__empty">
          Recent payments will appear here once you make a payment.
        </div>
      )}
    </aside>
  );
}
